"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MousePointerIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var MousePointerIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("defs", null,
        React.createElement("path", { d: "M8,3 L8,17.1315789 L12.5,17.1315789 L14.0394737,20.3684211 C14.1973684,20.7631579 14.5526316,21 14.9473684,21 C15.0657895,21 15.1842105,20.9605263 15.3026316,20.9210526 C15.8157895,20.7236842 16.0526316,20.1315789 15.8552632,19.6184211 L15.3026316,15.8084106 L18.1842105,13.1842105 L8,3 Z" })),
    React.createElement("g", { fill: "none" },
        React.createElement("use", { fill: "#000", xlinkHref: "#os-a" }),
        React.createElement("path", { stroke: "#FFF", d: "M15.835559,15.9993492 L16.3428289,19.4966223 C16.6004996,20.2545594 16.2325184,21.0990974 15.4607455,21.3953943 C15.3200895,21.4422796 15.2531924,21.462101 15.1568341,21.4799451 C15.0865762,21.4929558 15.0174151,21.5 14.9473684,21.5 C14.3413669,21.5 13.8065005,21.1322793 13.5879417,20.5831741 L12.1841343,17.6315789 L7.5,17.6315789 L7.5,1.79289322 L18.908231,13.2011242 L15.835559,15.9993492 Z" })))); };
exports.MousePointerIcon = MousePointerIcon;
